import { render, staticRenderFns } from "./ConfirmMessage.vue?vue&type=template&id=b546996e&scoped=true"
import script from "./ConfirmMessage.vue?vue&type=script&lang=ts"
export * from "./ConfirmMessage.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmMessage.vue?vue&type=style&index=0&id=b546996e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b546996e",
  null
  
)

export default component.exports